import { render, staticRenderFns } from "./TermsUse.vue?vue&type=template&id=280ff6a9&"
import script from "./TermsUse.vue?vue&type=script&lang=js&"
export * from "./TermsUse.vue?vue&type=script&lang=js&"
import style0 from "./TermsUse.vue?vue&type=style&index=0&id=280ff6a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports